<div [hidden]="consulta">
    <div class="row">
        <div class="col-lg-12" style="padding: 0px;">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}}: {{accion.accion}}</h3>
                </header>
                <div class="divisor32"></div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                        <inputCustom [titulo]="'Ciclo'" [disabled]="true" [(ngModel)]="entidad.ciclo" [errorActivo]="errorActivo" ></inputCustom>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                        <inputCustom [titulo]="'Nombre del periodo de evaluación'" [disabled]="true" [(ngModel)]="entidad.descripcion" [errorActivo]="errorActivo" ></inputCustom>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                        <datePickerV2Custom [titulo]="'Fecha Inicio de Periodo'" [disabled]="true"
                        [errorActivo]="errorActivo"
                        [(ngModel)]="entidad.fechainicioperiodo"
                        ></datePickerV2Custom>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                        <datePickerV2Custom [titulo]="'Fecha Inicio Acuerdos'" [disabled]="true"
                        [(ngModel)]="entidad.fechainicioacuerdos"
                        ></datePickerV2Custom>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                        <datePickerV2Custom [titulo]="'Fecha Fin Acuerdos'" [disabled]="true"
                        [(ngModel)]="entidad.fechafinacuerdos"
                        ></datePickerV2Custom>
                    </div>
                </div>

                <div *ngIf="accion.accionid == 1">
                    <h5>Asigne las evaluaciones para cada tipo de evaluación</h5>
                                <!-- datos -->
                                    <div >
                                        <dx-data-grid
                                        (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                                        id="tabla"
                                        [columnAutoWidth]="true"
                                        [dataSource]="SelDataPeriodoporTipo"
                                        [noDataText]="'Sin Datos'"
                                        [hoverStateEnabled]="true"
                                        [showColumnHeaders]="true"
                                        >
                                        <dxo-export [enabled]="false" [fileName]="sistemaService.NombrePantallaActual" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                                        <dxo-search-panel
                                            [visible]="true"
                                            [width]="240"
                                            placeholder="{{'Buscar' | translate}}">
                                        </dxo-search-panel>

                                        <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                                        <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                                        <dxo-pager
                                            [visible]="true"
                                            [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                                            [displayMode]="sistemaService.tablaPaginacionModo"
                                            [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                                            [showInfo]="sistemaService.tablaPaginacionInfo"
                                            [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                                        </dxo-pager>
                                        <dxi-column
                                            [allowExporting]="false"
                                            caption="Acciones"
                                            cellTemplate="cellAcciones"
                                            alignment="center"
                                            [minWidth]="120">

                                        </dxi-column>
                                        <dxi-column
                                            dataField="nombre"
                                            caption="Tipo de evaluación">
                                        </dxi-column>
                                        <dxi-column
                                            dataField="nivel"
                                            caption="Nivel">
                                        </dxi-column>
                                        <dxi-column
                                            dataField="fechainicioevaluacion"
                                            caption="Fecha inicio evaluación">
                                        </dxi-column>
                                        <!-- Acciones -->
                                        <div *dxTemplate="let cell of 'cellAcciones'">
                                            <a matTooltip="Ver" class="tablaBoton" (click)="Formulario(cell.data, 2)">
                                                <i class="fa fa-eye fa-lg" aria-hidden="true"></i>
                                            </a>
                                            <a matTooltip="Editar" class="tablaBoton separado edit" (click)="Formulario(cell.data, 1)" *ngIf="sistemaService.permisos.editar && (cell.data.validarfecha == 1 || sistemaService.permisos.edicionespecial)">
                                                <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                                            </a>
                                        </div>
                                    </dx-data-grid>
                            </div>
                </div>
                <div *ngIf="accion.accionid == 2">
                    <div class="panelBotonesFiltro mixto">
                        <button class="boton botonSM filledBlanco" (click)="AgruparAcuerdos()">Agrupar seleccionados</button>
                        <div class="divisorH16 "></div>
                        <button class="boton botonSM filledBlanco" (click)="DesagruparAcuerdos()" >Desagrupar seleccionados</button>
                    </div>
                    <div >
                        <dx-data-grid
                        (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                        id="tabla"
                        [columnAutoWidth]="true"
                        [dataSource]="SelColaborador"
                        [noDataText]="'Sin Datos'"
                        [hoverStateEnabled]="true"
                        [showColumnHeaders]="true"
                        (onRowPrepared)="onRowPrepared($event)"
                        >
                        <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                        <dxo-search-panel
                            [visible]="true"
                            [width]="240"
                            placeholder="{{'Buscar' | translate}}">
                        </dxo-search-panel>

                        <dxo-paging [pageSize]="50"></dxo-paging>
                        <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->
                        <dxo-editing mode="cell" [allowUpdating]="true"></dxo-editing>

                        <dxo-pager
                            [visible]="true"
                            [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                            [displayMode]="sistemaService.tablaPaginacionModo"
                            [showInfo]="sistemaService.tablaPaginacionInfo"
                            [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                        </dxo-pager>
                        <dxi-column [allowEditing]="true"
                        alignment="center"
                        dataField="seleccion"
                        caption="Selección"
                        dataType="boolean"
                    >
                    </dxi-column>
                        <dxi-column
                            dataField="activo"
                            caption="Estatus"
                            cellTemplate="cellAcciones"
                            [allowEditing]="false"
                            alignment="center"
                            [width]="150"
                            [customizeText]="formatBoolean">

                        </dxi-column>
                        <dxi-column [allowEditing]="false"
                        dataField="nombresubordinado"
                        [groupIndex]="0"
                        groupCellTemplate="groupCellTemplateColaborador"
                        [autoExpandGroup]="true">
                    </dxi-column>
                        <dxi-column [allowEditing]="false"
                            dataField="puestosubordinado"
                            caption="Puesto">
                        </dxi-column>
                        <dxi-column [allowEditing]="false"
                            dataField="departamentosubordinado"
                            caption="Departamento">
                        </dxi-column>
                        <dxi-column [allowEditing]="false"
                            dataField="materia"
                            caption="Materia o taller">
                        </dxi-column>
                        <dxi-column [allowEditing]="false"
                            dataField="nombre"
                            caption="Jefe">
                        </dxi-column>
                        <dxi-column [allowEditing]="false"
                        dataField="puesto"
                        caption="Puesto del jefe">
                        </dxi-column>
                        <dxi-column [allowEditing]="false"
                        dataField="reponsable"
                        caption="Jefe responsable del acuerdo">
                        </dxi-column>
                        <!-- Acciones -->
                        <div *dxTemplate="let cell of 'cellAcciones'">
                            <div class="row margen">
                                <div class="col-12" *ngIf="!cell.data.asignacionacuerdoresponsableid">
                                    <dx-switch class="myColor" [switchedOffText]="'Desactivado'" [switchedOnText]="'Activo'" [width]="90" [value]="cell.data.activo" (onValueChanged)="activardesactivar(cell.data, $event)" [matTooltip]="'El estatus Desactivado indica que no se muestra el acuerdo del colaborador en el módulo o sección de Acuerdos.'"></dx-switch>
                                </div>
                            </div>
                        </div>
                        <div *dxTemplate="let cellInfocolaborador of 'groupCellTemplateColaborador'">
                            <div class="accionEncabezado">
                                <div class="accionEncabezado__titulo">
                                    {{cellInfocolaborador.value}}
                                </div>
                                <div class="accionEncabezado__accionesintermedio">
                                    <span>{{cellInfocolaborador.data.total}} relaciones jefe - subordinado</span>
                                </div>
                                <div class="accionEncabezado__acciones">
                                    <span>{{cellInfocolaborador.data.texto}}</span>

                                </div>

                            </div>
                        </div>
                    </dx-data-grid>
            </div>
                </div>
                <div class="divisor20"></div>
                <div class="row margen" >
                    <div class="col-12">
                        <div class="panelBotonesFiltro">
                            <button matTooltip="Cancelar" class="boton botonSM filledBlanco"
                            (click)="Salir()">
                            <span> {{'Cancelar'}}</span>
                        </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>


<ng-container *ngIf="abierto">
    <div class="backdrop"></div>
    <div class="modalPanelAdmin animated {{animacion}}">

        <div class="contenido">
            <!-- Título -->
            <div class="encabezadoModal">
                <div class="modalTituloSimple">
                    {{('Seleccionar jefe')}}
                </div>
            </div>
            <div class="modalContenido">
                <!-- datos -->
                <div>
                    <div class="divisor8"></div>
                    <div>
                        <!-- Datos generales -->
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12" style="margin-bottom: 55px;">
                                <span>Selecciona el jefe encargado de realizar los acuerdos</span>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12" *ngIf="firmados.length > 0">
                              <span>Selecciona el acuerdo firmado</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                <dropdownCustom [titulo]="'Jefes'"
                                [opciones]="selectedRows"
                                [(ngModel)]="jeferesponsable"
                                [valorName]="'puestoporcolaboradorjefe'"
                                [displayValor]="'nombreypuestocol'"
                                [buscar]="false"
                                [errorActivo]="errorActivo"
                                ></dropdownCustom>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12" *ngIf="firmados.length > 0">
                              <dropdownCustom [titulo]="'Acuerdos firmados'"
                              [opciones]="firmados"
                              [(ngModel)]="firmaresponsable"
                              [valorName]="'asignacionacuerdofirmaid'"
                              [displayValor]="'nombreypuestocol'"
                              [buscar]="false"
                              [errorActivo]="errorActivo"
                              ></dropdownCustom>
                          </div>
                        </div>
                    </div>
                </div>

            </div>

            <!-- footer -->
            <div class="modalFooter">
                <div class="contenidoFooter botonesIzq">
                    <!-- editar -->
                    <div class="botonDerecha">
                        <button class="boton botonSM filledBlanco" (click)="CerrarModal()">
                            {{'Cancelar' | translate}}
                        </button>
                        <div class="divisorH16"></div>
                        <button class="boton botonSM filled" (click)="GuardarResponsable()" *ngIf="firmados.length == 0">
                            {{'Guardar' | translate}}
                        </button>
                        <button class="boton botonSM filled" (click)="Guardar()" *ngIf="firmados.length > 0">
                          {{'Guardar' | translate}}
                      </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>


<div #asignacionevaluacionevaluaciones></div>
